const inscritos = [
  {
    name: "",
    lastname: "",
    email: "",
    especialidade: ""
  },
]

export default inscritos